var map = {
	"./abot-1.png": 9754,
	"./abot-2.png": 865,
	"./abot-3.png": 648,
	"./agcwder-1.png": 3223,
	"./agcwder-2.png": 8396,
	"./classify-1.png": 264,
	"./classify-2.png": 4755,
	"./classify-3.png": 3994,
	"./fleeds-1.png": 5213,
	"./fleeds-2.png": 3590,
	"./fleeds-3.png": 9919,
	"./myfarm-1.png": 6888,
	"./myfarm-2.png": 3747,
	"./myfarm-3.png": 2170,
	"./nota-1.png": 9114,
	"./nota-2.png": 8097,
	"./nota-3.png": 5384,
	"./psb-1.png": 299,
	"./psb-2.png": 448,
	"./psb-3.png": 7353,
	"./road-width-1.png": 1151,
	"./road-width-2.png": 9684,
	"./road-width-3.png": 813,
	"./taskbound-1.png": 8773,
	"./taskbound-2.png": 3022,
	"./taskbound-3.png": 711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4188;